import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Link, Outlet } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import type { Auth } from "@/lib/auth";

export interface RouterContext {
  queryClient: QueryClient;
  auth: Auth;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Outlet,
  notFoundComponent: NotFound,
});

function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-start gap-3 px-6 py-16">
      <h1 className="text-2xl font-semibold">{t("notFound.title")}</h1>
      <p className="text-ink-muted">{t("notFound.body")}</p>
      <Link to="/" className="font-medium text-accent-ink hover:underline">
        {t("placeholder.backHome")}
      </Link>
    </div>
  );
}
